module.exports = __webpack_public_path__ + "img/next.71f6107d.svg";